import { Optional } from 'frontend/types';

/**
 * Use this when you want your component to have a nice, readable default value
 * (such as "continue_button") but to append that default to a prefix if given
 * (such as "my_new_page_continue_button")
 */
export function getTestId(prefix: Optional<string>, testId: string): string {
  return prefix ? `${prefix}_${testId}` : testId;
}
